import { CardContent, Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import TimeBasePremiumDetails from './components/TimeBasePremiumDetail'
import Dialog from "components/Dialog/Dialog";
import { actions as EmployerActions, selectors as EmployerSelectors } from 'store/modules/employerDetails'
import { useDispatch, useSelector } from 'react-redux';
import TimeBasePremiumForm from './components/TimeBasePremiumForm';
import { makeStyles } from "@mui/styles";
import Button from "components/Button/Button";

export const useStyles = makeStyles(() => ({

    cardHeading: {
        display: 'flex',
        '& button': {
            padding: '0'
        }
    },
    card: {
        height: '100%',
        position: "relative"
    },

    overlayLoading: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#d2d2d282"
    }
}));

export default function TimeBasePremiumTab() {
    const removeTimeBasePremiumDialog = useSelector(EmployerSelectors.GetRemoveTimeBasePremiumDialog);
    const isLoadingRemoveTimeBasePremium = useSelector(EmployerSelectors.getIsRemoveTimeBasePremiumLoading);
    const dispatch = useDispatch();
    const classes = useStyles();
    const [tab, setTab] = useState(0);


    const showNewTimeBasePremiumDialog = () => {
        setTab(1);
        dispatch(EmployerActions.setEditTimeBasePremiumForm());
    };
    const hideRemoveTimeBasePremiumDialog = () => {
        dispatch(EmployerActions.setRemoveTimeBasePremiumDialog(false));
    };
    const handleRemoveTimeBasePremium = () => {
        dispatch(EmployerActions.removeTimeBasePremium());
    };

    return (
        tab === 0 ? <>
            <Grid item xs={12} sm={12} md={12} className={classes.card}>
                <CardContent>
                    <Typography
                        sx={{ fontSize: 14 }}
                        className={classes.cardHeading}
                        color="text.secondary"
                        gutterBottom
                        justifyContent={"space-between"}
                    >
                        <div />
                        <div>
                            <Button
                                style={{ alignSelf: "flex-end", marginBottom: 16, padding: 0 }}
                                label="Add"
                                alignIcon="left"
                                onClick={showNewTimeBasePremiumDialog}
                            />
                        </div>
                    </Typography>
                    <TimeBasePremiumDetails setTab={(val) => setTab(val)} />
                </CardContent>
            </Grid>
            <Dialog
                open={removeTimeBasePremiumDialog}
                title={"Are You Sure?"}
                onClose={hideRemoveTimeBasePremiumDialog}
                onConfirm={handleRemoveTimeBasePremium}
                onCancel={hideRemoveTimeBasePremiumDialog}
                alertType="warning"
                icon="remove_circle"
                disabled={false}
                isLoading={isLoadingRemoveTimeBasePremium}
            />
        </> : <TimeBasePremiumForm setTab={(val) => setTab(val)} />
    )
}
